<template>
  <FreeBottomSheet :name="roamingConfig.INFO_BOTTOM_SHEET">
    <template #header="{ hide }">
      <FreeHeader class="bg-background-neutral-primary rounded-t-2xl p-4">
        <template #leftAction></template>
        <template #default>
          <h2
            class="text-text-neutral-primary text-center text-base font-medium"
          >
            {{ roamingProduct.title }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="bg-background-neutral-primary space-y-4 px-4 pb-4">
        <p class="text-text-positive-primary text-center text-2xl font-bold">
          {{ $t('general.price.free') }}
        </p>
        <div class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4">
          <p class="text-text-neutral-secondary text-sm font-medium">
            {{ roamingProduct.short_description }}
          </p>
          <p class="text-text-neutral-secondary text-sm font-medium">
            {{ roamingProduct.full_description }}
          </p>
          <button
            type="button"
            class="text-text-positive-primary text-sm font-semibold"
            @click="emit('onOpenDevices')"
          >
            {{ $t('roaming.check-device') }}
          </button>
        </div>
        <FreeButton
          class="w-full"
          :class="isSelected ? 'gray-button' : 'green-main-button'"
          @click="emit('onProductToggle')"
        >
          {{ isSelected ? $t('general.delete') : $t('general.add') }}
        </FreeButton>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
    FreeButton,
  } from 'freedom-shared';
  import type { Airflow } from '@aviata/platform-types';

  import { roamingConfig } from '../config';

  const emit = defineEmits<{
    onOpenDevices: [];
    onProductToggle: [];
  }>();

  defineProps<{
    roamingProduct: Airflow.Products.GenericProduct;
    isSelected: boolean;
  }>();
</script>
